import React from "react";
import { StyledCloseButton } from "./styles";
export const CloseButton = ({
  onClose
}) => /*#__PURE__*/React.createElement(StyledCloseButton, {
  onClick: onClose,
  "data-qa": "close-button"
});
CloseButton.displayName = "CloseButton";